import React, { useState } from 'react'
import { Stepper, Step, StepLabel, useMediaQuery } from '@mui/material'
import ADR from './componentsOrderService/ADR'
import { M_Button, M_DrawerTableTextField, M_InputTextField, M_CheckBox, M_TextArea, filtersSortService, M_Select, M_MessageBoard, MMap } from 'src/components/M_Components'
import M_RadioButton from 'src/components/M_Components/M_RadioButton/M_RadioButton'
import M_UploadFiles from 'src/components/M_Components/M_UploadFiles/M_UploadFiles'
import { t } from 'i18next'
import { WarningAmberOutlined } from '@mui/icons-material'

export default function CreateOrderServiceInTabs({ optionsOrderService, optionsADR, optionsServiceContainer, optionsRORO, optionsAddress, optionsReceiver,
    optionsShippingInformation, shippingInformation, setShippingInformation, ADRMap, setADRMap, addADR, container, setContainer, ROROMap, address, addAddress,
    deleteAddress, createStructureAddress, operation, ctx, optionsTransportResources, orderService, setOrderService, addOrderService, transportResources,
    setTransportResources, validateReceiver, createStructure, setOpenModalGenerator, activeStep, setActiveStep, setModalAddContainer, bufferServiceContainers,
    createAddresses, createStructureNewContainer, newContainer, setNewContainer, modalAddContainer, createNewContainer, optionsContainer, files, setFiles,
    optionsDigitalArchiveCategory, modalViewAddress, setModalViewAddress, optionsSubResource, transportSubResources }) {

    const steps = ['OrderService', 'TransportResources', 'Container/RORO', 'Addresses', 'OtherInformations', 'DigitalArchive']
    const matches = useMediaQuery("(max-width: 570px)")
    const matchesAlternative = useMediaQuery("(max-width: 1030px)")
    const filterService = new filtersSortService()


    const [selectedCategory, setSelectedCategory] = useState("")
    const [selectedCategoryId, setSelectedCategoryId] = useState("")
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [validateDistict, setValidateDistrict] = useState(false)
    const [invalidContainerInfo, setInvalidContainerInfo] = useState({ acronym: '', containerNumber: '' })


    //const do get por filtro do container
    const [infoContainer, setInfoContainer] = useState({})

    const getIcon = (file) => {
        const fileName = file.Name ?? file.name
        const fileExtension = fileName?.toLowerCase() || ""

        switch (true) {
            case fileExtension.endsWith('.pdf'):
                return "/UploadFilesImages/pdf.png"
            case fileExtension.endsWith('.txt'):
                return "/UploadFilesImages/txt.png"
            case fileExtension.endsWith('.xlsx'):
            case fileExtension.endsWith('.csv'):
                return "/UploadFilesImages/excel.png"
            case fileExtension.endsWith('.pptx'):
                return "/UploadFilesImages/powerpoint.png"
            case fileExtension.endsWith('.docx'):
            case fileExtension.endsWith('.odt'):
                return "/UploadFilesImages/office.png"
            case fileExtension.endsWith('.rar'):
            case fileExtension.endsWith('.7z'):
            case fileExtension.endsWith('.zip'):
                return "/UploadFilesImages/zip.png"
            case fileExtension.endsWith('.eml'):
                return "/UploadFilesImages/email.png"
            default:
                return "/UploadFilesImages/images.png" // fallback
        }
    }

    const sizeContainer = [
        { Name: 'Width', NormalizedName: 'Width', type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false },
        { Name: 'Height', NormalizedName: 'Height', type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false },
        { Name: 'Length', NormalizedName: 'Length', type: 'string', IsDisabled: false, IsRequired: false, IsHiddenList: false }
    ]

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const iso6346Map = {
        A: 10, B: 12, C: 13, D: 14, E: 15,
        F: 16, G: 17, H: 18, I: 19, J: 20,
        K: 21, L: 23, M: 24, N: 25, O: 26,
        P: 27, Q: 28, R: 29, S: 30, T: 31,
        U: 32, V: 34, W: 35, X: 36, Y: 37,
        Z: 38
    }

    // função para validar o código ISO 6346 dos contentores
    const isValidISO6346 = (acronym, containerNumber) => {
        if (!acronym || !containerNumber) return false
        if (acronym.length !== 4) return false
        if (acronym[3] !== 'U') return false

        const cleanNumber = containerNumber.replace('/', '')
        if (!/^\d{7}$/.test(cleanNumber)) return false

        const fullCode = acronym + cleanNumber.slice(0, 6)

        let sum = 0
        for (let i = 0; i < fullCode.length; i++) {
            const char = fullCode[i]
            const value = isNaN(char) ? iso6346Map[char] : Number(char)
            sum += value * Math.pow(2, i)
        }

        let checkDigit = sum % 11
        if (checkDigit === 10) checkDigit = 0

        return checkDigit === Number(cleanNumber[6])
    }

    const searchContainer = (acronym, containerNumber) => {
        const searchArgs = [
            {
                name: 'ContainerNumber',
                type: 'string',
                operation: 'Equals',
                value: containerNumber,
            },
            {
                name: 'Acronym',
                type: 'string',
                operation: 'Equals',
                value: acronym,
            }
        ]
        const filter = filterService.advancedSearch(searchArgs, true)
        bufferServiceContainers.filter('?' + filter).then((response) => {
            if (response.name === "AxiosError") {
                ctx.toastMessages('error', 'Erro', '')
                return
            }
            if (response.Items.length === 0) {
                const isValid = isValidISO6346(
                    acronym.toUpperCase(),
                    containerNumber
                )

                if (!isValid) {
                    setInvalidContainerInfo({
                        acronym: acronym?.toUpperCase() || '',
                        containerNumber: containerNumber || ''
                    })
                    setValidateDistrict(true)
                } else {
                    setModalAddContainer(true)
                }
            } else {
                setInfoContainer(response.Items)
            }
        })
    }


    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div className='divGlovalOrderServiceinTabs'>
                        <b>{t("InfoOrderService")}</b>
                        <div className='divGridOrderServiceinTabs'>
                            {optionsOrderService
                                .filter((elem) => elem.IsHiddenList !== true && elem.GroupByInfo === "")
                                .map((elem, key) =>
                                    elem.IsForeignKey ? (
                                        <M_DrawerTableTextField
                                            key={key}
                                            tableLabel={elem.NormalizedName}
                                            label={elem.NormalizedName}
                                            required={elem.IsRequired}
                                            entity={elem.Name === 'ReloadServiceOrder' ? "LinkableServiceOrderView" : elem.ForeignTableName}
                                            value={
                                                orderService.get(elem.ForeignTableToPassId)
                                                    ? {
                                                        [elem.ForeignTableToPassId]: orderService.get(elem.ForeignTableToPassId),
                                                        [elem.ForeignKeyName]: orderService.get(elem.Name),
                                                    }
                                                    : null
                                            }
                                            filterField={elem.TableColumnsFilter || elem.ForeignKeyName}
                                            labelFields={[elem.ForeignKeyName]}
                                            onSubmitValue={(obj) => {
                                                if (obj) {
                                                    orderService.set(elem.Name, obj[elem.ForeignKeyName])
                                                    orderService.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                                    if (elem.Name === 'ServiceType') {
                                                        orderService.set('IsImport', obj[elem.ForeignKeyName] === 'Importação')
                                                        orderService.set('IsExport', obj[elem.ForeignKeyName] === 'Exportação')
                                                    }
                                                    if (elem.Name === 'ReloadServiceOrder') {
                                                        orderService.set('Reload', true)
                                                    }
                                                } else {
                                                    orderService.set(elem.Name, null)
                                                    orderService.set(elem.ForeignTableToPassId, null)
                                                    if (elem.Name === 'ServiceType') {
                                                        orderService.set('IsImport', false)
                                                        orderService.set('IsExport', false)
                                                    }
                                                    if (elem.Name === 'ReloadServiceOrder') {
                                                        orderService.set('Reload', false)
                                                    }
                                                }
                                                if (obj?.[elem.ForeignKeyName] === 'Importação' || obj?.[elem.ForeignKeyName] === null) {
                                                    orderService.set('Full', false)
                                                    orderService.set('Reload', false)
                                                    orderService.set('RORO', false)
                                                }
                                                if (obj?.[elem.ForeignKeyName] === 'Importação') {
                                                    createAddresses()
                                                }
                                                setOrderService(new Map(orderService))
                                            }}
                                            disabled={
                                                elem.Name === 'ReloadServiceOrder'
                                                    ? orderService.get('ServiceType') === 'Exportação' && orderService.get('Reload') === true ?
                                                        false : true
                                                    : false
                                            }
                                            valueField={elem.ForeignTableToPassId}
                                        />

                                    ) : elem.Type === 'string' ? (
                                        <M_InputTextField
                                            key={key}
                                            type={"text"}
                                            label={elem.NormalizedName}
                                            onChange={(e) => addOrderService(e.target.value, elem.Name)}
                                            required={elem.IsRequired}
                                            value={orderService.get(elem.Name) || ""}
                                        />
                                    ) : elem.Type === 'datetime' ? (
                                        <M_InputTextField
                                            key={key}
                                            type="datetime-local"
                                            label={elem.NormalizedName}
                                            onChange={(e) => addOrderService(e.target.value, elem.Name)}
                                            required={elem.IsRequired}
                                            value={orderService.get(elem.Name) || ""}
                                            minDate={new Date().toISOString().slice(0, 16)}
                                        />
                                    ) : elem.Name === 'Market' ? (
                                        <M_Select
                                            noNone
                                            key={key}
                                            label={elem.NormalizedName}
                                            options={elem.EnumValues?.map(elem => ({
                                                label: elem.Label,
                                                value: elem.Value
                                            })) || []}
                                            onChange={(e) => addOrderService(e.target.value, elem.Name)}
                                            value={orderService.get(elem.Name) || ""}
                                        />
                                    ) : null
                                )
                            }

                            <div className='checkboxGroupOrderServiceinTabs'>
                                {optionsOrderService
                                    .filter(elem => elem.Type === 'boolean' && elem.IsHiddenList !== true && elem.GroupByInfo === "")
                                    .map((elem, key) => {
                                        const transportType = orderService.get('ServiceType')
                                        const isImportacao = transportType === 'Importação'

                                        const isDisabled = !transportType ? true : false ||
                                            (isImportacao && elem.Name === 'Full')

                                        return (
                                            <div className='divCheckboxFormQuotes' key={key}>
                                                <M_CheckBox
                                                    label={elem.NormalizedName}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked

                                                        addOrderService(checked, elem.Name)

                                                        const serviceType = orderService.get("ServiceType")

                                                        const reload = elem.Name === 'Reload'
                                                            ? checked
                                                            : orderService.get("Reload") || false

                                                        const full = elem.Name === 'Full'
                                                            ? checked
                                                            : orderService.get("Full") || false

                                                        if (elem.Name === 'Reload' || elem.Name === 'Full') {
                                                            createAddresses(serviceType, reload, full)
                                                        }
                                                    }}

                                                    checked={orderService.get(elem.Name) || false}
                                                    required={elem.IsRequired}
                                                    noPadding
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                )
            case 1:
                return (
                    <div className='divGlovalOrderServiceinTabs'>
                        <b>{t("TransportResourcesNecessary")} </b>

                        <div className='divGridTransportationResourcesinTabs'>
                            {optionsSubResource.map((elem => (
                                <M_CheckBox
                                    key={elem.Name}
                                    label={t(`resources.${elem.Name}`)}
                                    onChange={(e) => createStructure(e.target.checked, elem.Name, "SubResources")}
                                    checked={transportSubResources?.[elem.Name] ?? false}
                                    noPadding
                                    style={{ padding: '10px 0px 0px 10px' }}
                                    disabled={elem.Name === 'SpecialLicense' ? container?.SpecialDimensions === true ? true : false : false}
                                />
                            )))}
                        </div>


                        <div className='divGridTransportationResourcesinTabs'>
                            {optionsTransportResources.filter((elem) => elem.IsHiddenList !== true).map((elem1, key1) => (
                                <div key={key1} >
                                    {elem1.Type === 'boolean' ? (
                                        <div className='divCheckboxOrderServiceinTabs'>
                                            <M_CheckBox
                                                label={elem1.NormalizedName}
                                                onChange={(e) => createStructure(e.target.checked, elem1.Name, "Resources")}
                                                checked={transportResources[elem1.Name] !== undefined ? transportResources[elem1.Name] : false}
                                                noPadding
                                                style={{ padding: '10px 0px 0px 10px' }}
                                                disabled={elem1.Name === 'SpecialLicense' ? container?.SpecialDimensions === true ? true : false : false}
                                            />
                                        </div>
                                    ) : elem1.Type === 'string' ? (
                                        <div style={{ paddingRight: '20px' }}>
                                            <M_DrawerTableTextField
                                                key={key1}
                                                tableLabel={elem1.NormalizedName}
                                                label={elem1.NormalizedName}
                                                required={elem1.IsRequired}
                                                entity={elem1.ForeignTableName}
                                                value={transportResources[elem1.ForeignTableCurrentId] ? {
                                                    [elem1.ForeignKeyName]: transportResources[elem1.Name],
                                                    [operation === 'edit' ? elem1.ForeignTableCurrentId : elem1.ForeignTableToPassId]: transportResources[elem1.ForeignTableToPassId]
                                                } : null}
                                                filterField={elem1.TableColumnsFilter || elem1.ForeignKeyName}
                                                labelFields={[elem1.ForeignKeyName]}
                                                onSubmitValue={obj => {
                                                    let updatedTransportResources = { ...transportResources }
                                                    if (obj) {
                                                        updatedTransportResources[elem1.Name] = obj[elem1.ForeignKeyName]
                                                        updatedTransportResources[elem1.ForeignTableToPassId] = obj[elem1.ForeignTableToPassId]
                                                        updatedTransportResources[elem1.ForeignTableCurrentId] = obj[elem1.ForeignTableToPassId]

                                                    } else {
                                                        updatedTransportResources[elem1.Name] = null
                                                        updatedTransportResources[elem1.ForeignTableToPassId] = null
                                                        updatedTransportResources[elem1.ForeignTableCurrentId] = null

                                                    }
                                                    setTransportResources(updatedTransportResources)
                                                }}
                                                disabled={elem1.disable}
                                                valueField={elem1.ForeignTableToPassId}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ))}
                        </div>

                        {/* tabela do ADR */}
                        {transportResources?.ADR && (
                            <div className='divTableADROrderServiceinTabs'>
                                <div className='divButtonAddADROrderServiceinTabs'>
                                    <div className='divTitleADROrderServiceinTabs'>
                                        <div className='iconTitleCard'>
                                            <img src="/icons/svgsDaNet/radioactive.svg"
                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '40px' }}
                                                alt="ADR"
                                            />
                                        </div>
                                        <div className='labelTitleCard'>
                                            ADR
                                        </div>
                                    </div>
                                    <div>
                                        <M_Button
                                            label={t("AddADR")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addADR}
                                        />
                                    </div>
                                </div>
                                <ADR optionsADR={optionsADR} ADRMap={ADRMap} setADRMap={setADRMap} t={t} ctx={ctx} operation={operation} addADR={addADR} />
                            </div>
                        )}
                    </div>
                )
            case 2:
                return (
                    <div className='divGlovalOrderServiceinTabs'>
                        {!orderService?.get('RORO') && (
                            <div>
                                <b>{t("InfoContainer")} </b>
                                <div className='divGridOrderServiceinTabs'>
                                    {optionsServiceContainer.filter((elem) => elem.IsHiddenList !== true).map((elem2, key2) => {
                                        const safeContainer = container || {}
                                        return (
                                            <div key={key2} className={elem2.GroupByInfo === 'ContainerSize' ? elem2.Name === 'Length' ? 'span-two-columns' : 'no-span' : ''}>
                                                {elem2.IsForeignKey && elem2.Name !== 'Capacity' && (
                                                    <M_DrawerTableTextField
                                                        key={key2}
                                                        tableLabel={elem2.NormalizedName}
                                                        label={elem2.NormalizedName}
                                                        required={elem2.IsRequired}
                                                        entity={elem2.ForeignTableName}
                                                        value={safeContainer[elem2.ForeignTableToPassId] ?
                                                            {
                                                                [elem2.ForeignTableToPassId]: safeContainer[elem2.ForeignTableToPassId],
                                                                [elem2.ForeignKeyName]: safeContainer[elem2.Name]
                                                            } : null}
                                                        filterField={elem2.TableColumnsFilter || elem2.ForeignKeyName}
                                                        labelFields={[elem2.ForeignKeyName]}
                                                        onSubmitValue={obj => {
                                                            let updatedContainer = { ...safeContainer }
                                                            if (obj) {
                                                                updatedContainer[elem2.Name] = obj[elem2.ForeignKeyName]
                                                                updatedContainer[elem2.ForeignTableToPassId] = obj[elem2.ForeignTableToPassId]
                                                                updatedContainer.TemperatureControl = obj.TemperatureControl //Controlo de temperatura
                                                                updatedContainer.SpecialDimensions = obj.SpecialDimensions //Dimensões especiais
                                                                updatedContainer.TareWeight = obj.TareWeight //Tara
                                                                updatedContainer.PayLoad = obj.PayLoad //Payload
                                                            } else {
                                                                updatedContainer[elem2.Name] = null
                                                                updatedContainer[elem2.ForeignTableToPassId] = null
                                                                updatedContainer.TemperatureControl = null
                                                                updatedContainer.SpecialDimensions = null
                                                                updatedContainer.TareWeight = null
                                                                updatedContainer.PayLoad = null
                                                            }
                                                            setContainer(updatedContainer)
                                                            setNewContainer((prevContainer) => {
                                                                let updatedContainer = { ...prevContainer }
                                                                if (obj) {
                                                                    updatedContainer[elem2.Name] = obj[elem2.ForeignKeyName]
                                                                    updatedContainer[elem2.ForeignTableToPassId] = obj[elem2.ForeignTableToPassId]
                                                                } else {
                                                                    updatedContainer[elem2.Name] = null
                                                                    updatedContainer[elem2.ForeignTableToPassId] = null
                                                                }
                                                                return updatedContainer
                                                            })

                                                            const hasGeneratorSubResourceNames = (
                                                                optionsSubResource?.filter(sr => /generator/i.test(sr?.Name || '')).map(sr => sr.Name)
                                                            ) || ['Has Generator', 'HasGenerator', 'Generator']

                                                            const hasSpecialLicenseSubResourceNames = (
                                                                optionsSubResource?.filter(sr => /special[\s-]?license/i.test(sr?.Name || '')).map(sr => sr.Name)
                                                            ) || ['Special License', 'SpecialLicense']

                                                            const hasGenerator =
                                                                transportResources?.["Has Generator"] ??
                                                                transportResources?.HasGenerator ??
                                                                transportResources?.Generator ??
                                                                transportSubResources?.["Has Generator"] ??
                                                                transportSubResources?.HasGenerator ??
                                                                transportSubResources?.Generator ??
                                                                hasGeneratorSubResourceNames.some((name) => transportSubResources?.[name] === true)

                                                            const hasSpecialLicense =
                                                                transportResources?.["Special License"] ??
                                                                transportResources?.SpecialLicense ??
                                                                transportSubResources?.["Special License"] ??
                                                                transportSubResources?.SpecialLicense ??
                                                                hasSpecialLicenseSubResourceNames.some((name) => transportSubResources?.[name] === true)

                                                            if (updatedContainer.TemperatureControl !== true && hasGenerator) {
                                                                setTransportResources(prevState => ({
                                                                    ...prevState,
                                                                    ["Has Generator"]: false,
                                                                    HasGenerator: false,
                                                                    Generator: false
                                                                }))
                                                                hasGeneratorSubResourceNames.forEach((name) => createStructure(false, name, "SubResources"))
                                                            }

                                                            if ((hasGenerator === false || hasGenerator === undefined) && updatedContainer.TemperatureControl === true) {
                                                                setOpenModalGenerator(true)
                                                            }

                                                            if ((hasSpecialLicense === false || hasSpecialLicense === undefined) && updatedContainer.SpecialDimensions === true) {
                                                                setTransportResources(prevState => ({
                                                                    ...prevState,
                                                                    ["Special License"]: true,
                                                                    SpecialLicense: true
                                                                }))
                                                                hasSpecialLicenseSubResourceNames.forEach((name) => createStructure(true, name, "SubResources"))
                                                            }

                                                            if (updatedContainer.SpecialDimensions === null || updatedContainer.SpecialDimensions === undefined) {
                                                                setTransportResources(prevState => ({
                                                                    ...prevState,
                                                                    ["Special License"]: false,
                                                                    SpecialLicense: false
                                                                }))
                                                                hasSpecialLicenseSubResourceNames.forEach((name) => createStructure(false, name, "SubResources"))
                                                            }
                                                        }}
                                                        disabled={safeContainer.Capacity ? false : true}
                                                        valueField={elem2.ForeignTableToPassId}
                                                        FILTER={`ContainerCapacityId eq ${safeContainer.CapacityId || ''}`}
                                                    />
                                                )}
                                                {elem2.Type === 'string' && !elem2.IsForeignKey && (
                                                    <M_InputTextField
                                                        key={key2}
                                                        type={"text"}
                                                        label={elem2.NormalizedName}
                                                        required={elem2.IsRequired}
                                                        disabled={elem2.disable}
                                                        onChange={(e) => {
                                                            let value = e.target.value
                                                            if (elem2.Name === 'ContainerNumber') {
                                                                if (value.length === 6 && !value.includes('/')) {
                                                                    value = value.slice(0, 6) + '/' + value.slice(6)
                                                                }
                                                            }
                                                            createStructure(value, elem2.Name, "Container")
                                                            createStructureNewContainer(value, elem2.Name)
                                                        }}
                                                        value={safeContainer[elem2.Name] || ""}
                                                        placeholder={elem2.Name === 'ContainerNumber' ? 'xxxxxx/x' : null}
                                                        autocomplete={false}
                                                        onBlur={() => {
                                                            if (
                                                                (elem2.Name === 'ContainerNumber' || elem2.Name === 'Acronym') &&
                                                                safeContainer.Acronym &&
                                                                safeContainer.ContainerNumber
                                                            ) {
                                                                searchContainer(safeContainer.Acronym, safeContainer.ContainerNumber)
                                                            }
                                                        }}
                                                        maxNumbers={elem2.Name === 'Acronym' ? 4 : elem2.Name === 'ContainerNumber' ? 8 : null}
                                                    />
                                                )}
                                                {elem2.Type === 'boolean' && (
                                                    <div className='divCheckboxFormQuotes'>
                                                        <M_CheckBox
                                                            key={key2}
                                                            label={elem2.NormalizedName}
                                                            onChange={(e) => createStructure(e.target.checked, elem2.Name, "Container")}
                                                            checked={safeContainer[elem2.Name] !== undefined ? safeContainer[elem2.Name] : false}
                                                            required={elem2.IsRequired}
                                                            noPadding
                                                            style={{ padding: '10px 0px 0px 10px' }}
                                                        />
                                                    </div>
                                                )}
                                                {elem2.Type === 'int32' && elem2.Name !== 'Capacity' && (
                                                    <M_InputTextField
                                                        key={key2}
                                                        type={"number"}
                                                        label={elem2.NormalizedName}
                                                        required={elem2.IsRequired}
                                                        disabled={elem2.Name === "Temperature" ? !safeContainer.TemperatureControl : elem2.Name === 'LoadWeight' ? true : false}
                                                        onChange={(e) => {
                                                            createStructure(e.target.value, elem2.Name, "Container")
                                                            createStructureNewContainer(e.target.value, elem2.Name)
                                                        }}
                                                        value={elem2.Name !== 'LoadWeight' ? safeContainer[elem2.Name] || "" : ((+(safeContainer.TareWeight || 0)) + (+(safeContainer.NetWeight || 0))) || 0}
                                                        iconEnd={elem2.Name === 'Temperature' ? "ºC" : ""}
                                                        iconStart={elem2.Name === 'LoadWeight' && ((safeContainer.TareWeight || 0) + (safeContainer.NetWeight || 0) || 0) > (safeContainer.PayLoad || 0) ? <WarningAmberOutlined style={{ color: 'red' }} /> : null
                                                        }
                                                    />
                                                )}
                                                {elem2.Type === 'int32' && elem2.Name === 'Capacity' && (
                                                    <M_DrawerTableTextField
                                                        key={key2}
                                                        tableLabel={elem2.NormalizedName}
                                                        label={elem2.NormalizedName}
                                                        required={elem2.IsRequired}
                                                        entity={elem2.ForeignTableName}
                                                        value={{
                                                            [elem2.Name]: safeContainer[elem2.Name] || ""
                                                        }}
                                                        filterField={elem2.Name}
                                                        labelFields={[elem2.Name]}
                                                        onSubmitValue={obj => {
                                                            let updatedContainer = { ...safeContainer }
                                                            if (obj) {
                                                                updatedContainer[elem2.Name] = obj[elem2.ForeignKeyName]
                                                                updatedContainer[elem2.ForeignTableToPassId] = obj[elem2.ForeignTableToPassId]
                                                            } else {
                                                                updatedContainer[elem2.Name] = null
                                                                updatedContainer[elem2.ForeignTableToPassId] = null
                                                            }
                                                            setContainer(updatedContainer)
                                                            setNewContainer(updatedContainer)
                                                        }}
                                                        disabled={elem2.disable}
                                                        valueField={elem2.Name}
                                                    />
                                                )}
                                                {elem2.GroupByInfo === "ContainerSize" && elem2.Name === 'Length' && (
                                                    <div className='divPrincipalAlignInputsSize'>
                                                        {sizeContainer.map((size, index) => (
                                                            <div key={index} className='divAlignInputsSize'>
                                                                <div>
                                                                    <M_InputTextField
                                                                        key={index}
                                                                        type={"decimal"}
                                                                        label={t(size.NormalizedName)}
                                                                        required={!safeContainer.SpecialDimensions}
                                                                        disabled={!safeContainer.SpecialDimensions}
                                                                        onChange={(e) => createStructure(e.target.value, size.Name, "Container")}
                                                                        value={safeContainer[size.Name] || ""}
                                                                    />
                                                                </div>
                                                                {index !== sizeContainer.length - 1 && (
                                                                    <img src="/icons/svgsDaNet/x.svg" alt="" className='imgXSize' />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                                {infoContainer && Object.keys(infoContainer).length > 0 ?
                                    <div className='divInfoContainerOrderServiceinTabs'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img src="/icons/svgsDaNet/info.svg"
                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '25px', marginRight: '10px' }}
                                                alt="Info"
                                            />
                                            <b>{t("ContainerDetails")} </b>
                                        </div>
                                        <div className='displayInfoContainerOrderServiceinTabs'>
                                            <div><b>{t("Capacity")}:</b> {infoContainer[0].Capacity || '..'}</div>
                                            <div><b>{t("ContainerType")}:</b> {infoContainer[0].Type || '--'}</div>
                                            <div><b>{t("Tara")}:</b> {infoContainer[0].TareWeight || '--'} Kg</div>
                                            <div><b>Max:</b> {infoContainer[0].MaxLoadWeight || '--'} Kg</div>
                                            <div><b>{t("ContainerNumber")}</b> {infoContainer[0].Acronym} {infoContainer[0].ContainerNumber} </div>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        )}

                        {/* informação do RORO */}
                        {orderService?.get('RORO') && (
                            <div>
                                <b>{t("InfoRORO")}</b>
                                <div className='divGridOrderServiceinTabs'>
                                    {optionsRORO.filter((elem) => elem.IsHiddenList !== true).map((elem3, key3) => (
                                        <div key={key3}>
                                            {elem3.Type === 'string' ? (
                                                <M_InputTextField
                                                    type={"text"}
                                                    label={elem3.NormalizedName}
                                                    required={elem3.IsRequired}
                                                    disabled={elem3.disable}
                                                    onChange={(e) => createStructure(e.target.value, elem3.Name, "RORO")}
                                                    value={ROROMap[elem3.Name] || ""}
                                                />
                                            ) : elem3.Type === 'boolean' ? (
                                                <div className='divCheckboxFormQuotes'>
                                                    <M_CheckBox
                                                        label={elem3.NormalizedName}
                                                        onChange={(e) => createStructure(e.target.checked, elem3.Name, "RORO")}
                                                        checked={ROROMap[elem3.Name] !== undefined ? ROROMap[elem3.Name] : false}
                                                        required={elem3.IsRequired}
                                                    />
                                                </div>
                                            ) : elem3.Type === 'int32' || elem3.Type === 'decimal' ? (
                                                <M_InputTextField
                                                    type={"number"}
                                                    label={elem3.NormalizedName}
                                                    required={elem3.IsRequired}
                                                    disabled={elem3.disable}
                                                    onChange={(e) => createStructure(e.target.value, elem3.Name, "RORO")}
                                                    value={ROROMap[elem3.Name] || ""}
                                                />
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )
            case 3:
                return (
                    <div className='divGlovalOrderServiceinTabs'>
                        <div className='divButtonAddAddress'>
                            <b>{t("ListAddress")} </b>
                            <M_Button
                                label={t("AddLocal")}
                                icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                    style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                    alt="save" />
                                }
                                borderColor={'var(--color-grey)'}
                                onClick={addAddress}
                            />
                        </div>
                        <div className='divGlobalBlockAddressListOrderServiceinTabs'>
                            <div>
                                {address.map((addr, index) => (
                                    <div key={index} className='divBlockAddressOrderSericesinTabs'>
                                        <div className='divTitleAddressOrderServiceinTabs'>
                                            <div className='divAlignTitleAddressOrderServiceinTabs'>
                                                <img
                                                    src={
                                                        addr.AddressType === 'Pickup' ? "/icons/svgsDaNet/arrow-narrow-up.svg" :
                                                            addr.AddressType === 'Delivery' ? "/icons/svgsDaNet/arrow-narrow-down.svg" :
                                                                "/icons/svgsDaNet/crane.svg"
                                                    }
                                                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                    alt="Levante" className='iconCardAddress'
                                                />
                                                <div className='labelCardAddress'>
                                                    {t(`${addr.AddressType}`)}
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <M_Button
                                                    icon={<img src="/icons/svgsDaNet/map-pin.svg"
                                                        style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                        alt="map-pin" className='iconDeleteAddress'
                                                    />
                                                    }
                                                    label={t('ViewAddress')}
                                                    borderColor={'var(--color-grey-light)'}
                                                    onClick={() => {
                                                        setModalViewAddress(true)
                                                        setSelectedAddress(addr.Id)
                                                    }}
                                                />
                                                {addr.AddressType === 'Charge/Discharge' && (
                                                    <M_Button
                                                        icon={<img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress'
                                                        />
                                                        }
                                                        onClick={() => deleteAddress(addr.Id)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className='divAlignInputsAddressOrderServiceinTabs'>
                                            {optionsAddress.filter((elem) => elem.IsHiddenList !== true && elem.Name !== 'AddressType').map((address1, key1) =>
                                                address1.IsForeignKey ? (
                                                    <M_DrawerTableTextField
                                                        key={key1}
                                                        tableLabel={address1.NormalizedName}
                                                        label={address1.NormalizedName}
                                                        required={address1.IsRequired}
                                                        entity={address1.ForeignTableName}
                                                        value={addr[address1.ForeignTableToPassId] && {
                                                            [address1.ForeignTableToPassId]: addr[address1.ForeignTableToPassId],
                                                            [address1.ForeignKeyName]: addr[address1.Name]
                                                        } || null}
                                                        filterField={address1.ForeignKeyName}
                                                        labelFields={[address1.ForeignKeyName]}
                                                        onSubmitValue={(obj) => {
                                                            if (address1.Name === 'AddressCountryCode') {
                                                                const updates = {
                                                                    [address1.ForeignKeyName]: obj ? obj[address1.ForeignTableToPassId] || '' : '',
                                                                    [address1.ForeignTableToPassId]: obj ? obj[address1.ForeignTableToPassId] || '' : ''
                                                                }
                                                                createStructureAddress(updates, addr.Id)
                                                            } else {
                                                                const updates = {
                                                                    [address1.ForeignKeyName]: obj ? obj[address1.ForeignKeyName] || '' : '',
                                                                    [address1.ForeignTableToPassId]: obj ? obj[address1.ForeignTableToPassId] || '' : '',
                                                                    AddressName: obj ? obj.AddressName || '' : '',
                                                                    AddressPlace: obj ? obj.AddressPlace || '' : '',
                                                                    AddressStreet: obj ? obj.AddressStreet || '' : '',
                                                                    AddressZipCode: obj ? obj.AddressZipCode || '' : '',
                                                                    AddressZipPlace: obj ? obj.AddressZipPlace || '' : '',
                                                                    Latitude: obj ? obj.Latitude || '' : '',
                                                                    Longitude: obj ? obj.Longitude || '' : '',
                                                                    Notes: obj ? obj.Notes || '' : '',
                                                                    AddressCountryCode: obj ? obj.AddressCountryCode || '' : '',
                                                                    CountryA2: obj ? obj.AddressCountryCode || '' : ''
                                                                }
                                                                if (addr.AddressType !== 'Charge/Discharge') {
                                                                    updates.InitialDate = obj ? obj.InitialDate || '' : ''
                                                                    updates.FinalDate = obj ? obj.FinalDate || '' : ''
                                                                }
                                                                createStructureAddress(updates, addr.Id)
                                                            }
                                                        }}

                                                        disabled={address1.disable}
                                                        valueField={address1.ForeignTableToPassId}
                                                    />
                                                ) : address1.Type === 'string' && address1.Name === 'Notes' ? (
                                                    addr.AddressType === 'Charge/Discharge' ? (
                                                        <div key={key1} className='InputNotesAddressOrderServiceinTabs'>
                                                            <M_InputTextField
                                                                type="text"
                                                                label={address1.NormalizedName}
                                                                onChange={(e) => createStructureAddress({ [address1.Name]: e.target.value }, addr.Id)}
                                                                required={address1.IsRequired}
                                                                disabled={address1.disabled}
                                                                value={addr[address1.Name] || ""}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <M_InputTextField
                                                            key={key1}
                                                            type="text"
                                                            label={address1.NormalizedName}
                                                            onChange={(e) => createStructureAddress({ [address1.Name]: e.target.value }, addr.Id)}
                                                            required={address1.IsRequired}
                                                            disabled={address1.disabled}
                                                            value={addr[address1.Name] || ""}
                                                        />
                                                    )
                                                ) : address1.Type === 'string' ? (
                                                    <M_InputTextField
                                                        key={key1}
                                                        type="text"
                                                        label={address1.NormalizedName}
                                                        onChange={(e) => createStructureAddress({ [address1.Name]: e.target.value }, addr.Id)}
                                                        required={address1.IsRequired}
                                                        disabled={address1.disabled}
                                                        value={addr[address1.Name] || ""}
                                                    />
                                                ) : address1.Type === 'datetime' && addr.AddressType !== 'Charge/Discharge' ? (
                                                    <M_InputTextField
                                                        key={key1}
                                                        type="datetime-local"
                                                        label={addr.AddressType === 'Pickup' ? "Cut Off Levante" : "Cut Off Entrega"}
                                                        onChange={(e) => createStructureAddress({ [address1.Name]: e.target.value }, addr.Id)}
                                                        required={addr.AddressType !== 'Charge/Discharge' ? address1.IsRequired : false}
                                                        disabled={address1.disabled}
                                                        value={addr[address1.Name] || ""}
                                                        maxDate={addr.AddressType === 'Pickup' && orderService.get('TransportDate') ? new Date(orderService.get('TransportDate')).toISOString().slice(0, 16) : null}
                                                        minDate={addr.AddressType === 'Delivery' && orderService.get('TransportDate') ? new Date(orderService.get('TransportDate')).toISOString().slice(0, 16) : null}
                                                    />
                                                ) : null
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                )
            case 4:
                return (
                    <div className='divGlovalOrderServiceinTabs'>
                        <b>{t("InfoEntitiesShipNotes")} </b>
                        <div className='divAlignBlockOtherInformationOrderServiceinTabs'>
                            {/* painel entities */}
                            <div className='divPanelOtherInformationOrderServiceinTabs'>
                                <div className='divTitleADROrderServiceinTabs'>
                                    <div className='iconTitleCard'>
                                        <img src="/icons/svgsDaNet/flag-1.5.svg"
                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '40px' }}
                                            alt="Entities"
                                        />
                                    </div>
                                    <div className='labelTitleCard'>
                                        {t("Entities")}
                                    </div>
                                </div>
                                <div className='marginTopInputReceiver'>
                                    {optionsOrderService.filter((elems) => elems.GroupByInfo === 'Recetor').map((elem6, key6) => (
                                        <div key={key6}>
                                            {elem6.Type === 'string' ? (
                                                <M_DrawerTableTextField
                                                    tableLabel={elem6.NormalizedName}
                                                    label={elem6.NormalizedName}
                                                    required={orderService.get('SelectedReceiver') !== 'Other' ? elem6.Name === 'Shipper' ? false : true : true}
                                                    entity={elem6.ForeignTableName}
                                                    value={orderService.get(elem6.ForeignTableCurrentId) ?
                                                        {
                                                            [elem6.ForeignKeyName]: orderService.get(elem6.Name),
                                                            [operation === 'edit' ? elem6.ForeignTableCurrentId : elem6.ForeignTableToPassId]: orderService.get(
                                                                operation === 'edit' ? elem6.ForeignTableCurrentId : elem6.ForeignTableToPassId
                                                            )
                                                        } : null}

                                                    filterField={elem6.ForeignKeyName}
                                                    labelFields={[elem6.ForeignKeyName]}
                                                    onSubmitValue={obj => {
                                                        if (obj) {
                                                            orderService.set(elem6.Name, obj[elem6.ForeignKeyName])
                                                            orderService.set(elem6.ForeignTableToPassId, obj[elem6.ForeignTableToPassId])
                                                            orderService.set(elem6.ForeignTableCurrentId, obj[elem6.ForeignTableToPassId])

                                                        } else {
                                                            orderService.set(elem6.Name, null)
                                                            orderService.set(elem6.ForeignTableToPassId, null)
                                                            orderService.set(elem6.ForeignTableCurrentId, null)

                                                        }
                                                        setOrderService(new Map(orderService))
                                                    }}
                                                    disabled={orderService.get('SelectedReceiver') !== 'Other' ? elem6.Name === 'Shipper' ? true : false : null}
                                                    valueField={elem6.ForeignTableToPassId}
                                                />
                                            ) : elem6.Type === 'boolean' && key6 === 1 ? (
                                                <div className='divAlignRadioButtonsOrderServiceinTabs'>
                                                    <M_RadioButton
                                                        options={optionsReceiver}
                                                        onChange={(e) => validateReceiver(e.target.value)}
                                                        selectedValue={orderService.get('SelectedReceiver') || ""}
                                                        required={true}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* painel das informações do navio */}
                            <div className='divPanelOtherInformationOrderServiceinTabs'>
                                <div className='divTitleADROrderServiceinTabs'>
                                    <div className='iconTitleCard'>
                                        <img src="/icons/svgsDaNet/ship.svg"
                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '40px' }}
                                            alt="Ship"
                                        />
                                    </div>
                                    <div className='labelTitleCard'>
                                        {t("ShippingInformation")}
                                    </div>
                                </div>
                                {optionsShippingInformation.filter((elem) => elem.IsHiddenList !== true).map((elem5, key5) => {
                                    const safeShippingInformation = shippingInformation || {}
                                    return (
                                        <div key={key5} className='divInputsOtherInformationOrderServiceinTabs'>
                                            {elem5.IsForeignKey ? (
                                                <M_DrawerTableTextField
                                                    tableLabel={elem5.NormalizedName}
                                                    label={elem5.NormalizedName}
                                                    required={elem5.IsRequired}
                                                    entity={elem5.ForeignTableName}
                                                    value={safeShippingInformation[elem5.ForeignTableToPassId] ?
                                                        {
                                                            [elem5.ForeignTableToPassId]: safeShippingInformation[elem5.ForeignTableToPassId],
                                                            [elem5.ForeignKeyName]: safeShippingInformation[elem5.Name]
                                                        } : null}
                                                    filterField={elem5.ForeignKeyName}
                                                    labelFields={[elem5.ForeignKeyName]}
                                                    onSubmitValue={obj => {
                                                        let updatedShippingInformation = { ...safeShippingInformation }

                                                        if (obj) {
                                                            updatedShippingInformation[elem5.Name] = obj[elem5.ForeignKeyName]
                                                            updatedShippingInformation[elem5.ForeignTableToPassId] = obj[elem5.ForeignTableToPassId]
                                                            updatedShippingInformation.UEMember = obj.UEMember
                                                        } else {
                                                            updatedShippingInformation[elem5.Name] = null
                                                            updatedShippingInformation[elem5.ForeignTableToPassId] = null
                                                            updatedShippingInformation.UEMember = null
                                                        }

                                                        const dispatchValue = updatedShippingInformation.UEMember === false
                                                        setShippingInformation(prevState => ({
                                                            ...prevState,
                                                            ...updatedShippingInformation,
                                                            Dispatch: dispatchValue,
                                                        }))
                                                    }}

                                                    disabled={elem5.disable}
                                                    valueField={elem5.ForeignTableToPassId}
                                                />
                                            ) : elem5.Type === 'string' ? (
                                                <M_InputTextField
                                                    type={"text"}
                                                    label={elem5.NormalizedName}
                                                    required={elem5.IsRequired}
                                                    disabled={elem5.disable}
                                                    onChange={(e) => createStructure(e.target.value, elem5.Name, 'ShippingInformation')}
                                                    value={safeShippingInformation[elem5.Name] || ""}
                                                />
                                            ) : elem5.Type === 'boolean' ? (
                                                <div className='divCheckboxFormQuotes'>
                                                    <M_CheckBox
                                                        label={elem5.NormalizedName}
                                                        onChange={(e) => createStructure(e.target.checked, elem5.Name, 'ShippingInformation')}
                                                        checked={safeShippingInformation[elem5.Name] || false}
                                                        required={elem5.IsRequired}
                                                    />
                                                </div>
                                            ) : ""}
                                        </div>
                                    )
                                })}
                            </div>
                            {/* painel das Observações */}
                            <div className='divPanelOtherInformationOrderServiceinTabs'>
                                <div className='divTitleADROrderServiceinTabs'>
                                    <div className='iconTitleCard'>
                                        <img src="/icons/svgsDaNet/info-circle.svg"
                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '40px' }}
                                            alt="Info"
                                        />
                                    </div>
                                    <div className='labelTitleCard'>
                                        {t("Observations")}
                                    </div>
                                </div>
                                {optionsOrderService.filter((elem) => elem.GroupByInfo === 'Notes').map((elem6, key6) => (
                                    <div key={key6} className='divInputsOtherInformationOrderServiceinTabs'>
                                        <M_TextArea
                                            label={elem6.NormalizedName}
                                            required={elem6.IsRequired}
                                            onChange={(e) => addOrderService(e.target.value, elem6.Name)}
                                            value={orderService.get(elem6.Name) || ""}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )
            case 5:
                return (
                    <div>
                        <div className='divAlignCategoryUploadFilesOrderServiceinTabs'>
                            <div className='divPrincipalCategoryUploadFiles'>
                                <h3>{t("Category")}</h3>
                                <h5>{t("SelectCategory")} </h5>
                                <div className='divAlignCategoriesDigitalArchiveOrderServiceinTabs'>
                                    <M_Select
                                        label={t("Category")}
                                        options={optionsDigitalArchiveCategory.map((value) => ({
                                            label: value.Name,
                                            value: value.DigitalArchiveCategoryId,
                                        }))}
                                        value={selectedCategoryId}
                                        onChange={(e) => {
                                            const selectedId = e.target.value
                                            const selected = optionsDigitalArchiveCategory.find(opt => opt.DigitalArchiveCategoryId === selectedId)
                                            setSelectedCategoryId(selectedId)
                                            setSelectedCategory(selected)
                                        }}
                                        required={true}
                                    />

                                </div>
                            </div>
                            <div className='divPrincipalUploadFiles'>
                                <M_UploadFiles
                                    initialFiles={files}
                                    maxSize={15000000}
                                    multipleFiles={true}
                                    nameURL="uploadedFiles"
                                    operation={operation}
                                    disabled={selectedCategory === ""}
                                    onFilesChange={setFiles}
                                    transformFiles={(newFiles) =>
                                        newFiles.map((file) => ({
                                            ...file,
                                            DigitalArchiveCategoryId:
                                                file.DigitalArchiveCategoryId ?? selectedCategoryId,
                                            DigitalArchiveCategory:
                                                file.DigitalArchiveCategory ?? selectedCategory?.Name,
                                            id: file.id || file.Id || `${file.name}-${Date.now()}`
                                        }))
                                    }

                                    bodyImage={(file) => {
                                        const getFile = files.find((f) => f.Name === file.name)
                                        if (!getFile) return null

                                        return (
                                            <div style={{ display: 'flex', alignItems: 'center', width: '100%', paddingLeft: '30px' }}>
                                                <span style={{ marginRight: '10px' }}><b>{t("Category")}:</b> {getFile.DigitalArchiveCategory}</span>
                                            </div>
                                        )
                                    }}
                                />

                                {files.length > 0 && (
                                    <div>
                                        <div className="divAlignFiles">
                                            {files.map((file, key) => (
                                                <div key={key} className="divAlignEachFile">
                                                    <img
                                                        src={getIcon(file)}
                                                        alt="ícone do ficheiro"
                                                        style={{ width: 40, height: 40, marginRight: 8 }}
                                                    />
                                                    <div>
                                                        <div className="fontSizeLabelsOrderService divInputObservations">
                                                            <b>{file.Name}</b>
                                                        </div>
                                                        <div style={{ fontSize: "13px", color: "var(--color-grey-dark)" }}>
                                                            {t("Category")}: {file.DigitalArchiveCategory || selectedCategory?.Name}
                                                            <span style={{ marginLeft: 10 }}>{file.InsertionDate}</span>
                                                        </div>
                                                    </div>
                                                    <div style={{ marginLeft: "20px" }}>
                                                        <M_Button
                                                            icon={
                                                                <img
                                                                    src="/icons/svgsDaNet/trash-2.svg"
                                                                    alt="delete"
                                                                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)', width: '25px', cursor: 'pointer' }}
                                                                />
                                                            }
                                                            tooltip={t("Delete")}
                                                            onClick={() => {
                                                                const updatedFiles = files.filter((f) => f.Name !== file.Name)
                                                                setFiles(updatedFiles)
                                                            }}

                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>

                )
            default:
                return <div>Formulário Finalizado</div>
        }
    }

    return (
        <div className='divGlobalCreateOrderServiceInTabs'>
            <div className='divPrincoipalTitleOrderServiceinTabs'>
                <div className='titleTab'>
                    <img
                        src={activeStep === 0 ? "/icons/svgsDaNet/truck.svg" :
                            activeStep === 1 ? "/icons/svgsDaNet/forklift.svg" :
                                activeStep === 2 ? "/icons/svgsDaNet/box.svg" :
                                    activeStep === 3 ? "/icons/svgsDaNet/home.svg" :
                                        activeStep === 4 ? "/icons/svgsDaNet/info-circle.svg" :
                                            activeStep === 5 ? "/icons/svgsDaNet/upload-1.5.svg" :
                                                "/icons/svgsDaNet/crane.svg"
                        }
                        alt='icon'
                        style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                    />
                    {t(steps[activeStep])}
                </div>
                <div className='divLabelStatus'>
                    <b>{t("Status")}:</b>
                    <div className='divBodyStatus' style={{ backgroundColor: orderService.get('StateColor') || "#000000" }}>
                        {orderService.get('ServiceOrderState') || "Draft"}
                    </div>
                </div>
            </div>
            <Stepper
                alternativeLabel={matchesAlternative && !matches}
                orientation={matches ? "vertical" : "horizontal"}
                activeStep={activeStep}
                sx={{
                    '& .MuiStep-root': {
                        '& .Mui-completed .MuiStepIcon-root': {
                            color: 'var(--color-red-dark)',
                        },
                        '& .Mui-completed .MuiStepConnector-line': {
                            borderColor: 'var(--color-red-dark)',
                        },
                        '& .MuiStepIcon-root.Mui-active': {
                            color: 'var(--color-red-light)'
                        }
                    },
                }}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel><b>{t(label)}</b></StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                <div className='divButtonsBackNext'>
                    <div className='divButtonBack'>
                        <M_Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable"></i>}
                            borderColor={'var(--color-grey)'}
                        />
                    </div>
                    <div className='divButtonNext'>
                        <M_Button
                            onClick={handleNext}
                            disabled={activeStep === steps.length - 1}
                            label={t("Next")}
                            icon={<i className="pi pi-arrow-right iconTable"></i>}
                            borderColor={'var(--color-grey)'}
                            iconPosition={'right'}
                        />
                    </div>
                </div>
                {getStepContent(activeStep)}
            </div>

            {/* Modal de criação de contentores */}
            <M_MessageBoard
                open={modalAddContainer}
                onClose={() => setModalAddContainer(false)}
                title={
                    <div className='divTitleMessageBoardInformation'>
                        <img src="/icons/svgsDaNet/box.svg"
                            style={{ filter: 'invert(46%) sepia(40%) saturate(3365%) hue-rotate(71deg) brightness(90%) contrast(101%)', width: '35px', marginRight: '10px' }}
                            alt="OrderService"
                        />
                        {t("CreateNewContainer")}
                    </div>
                }
                body={
                    <div className='divDisplayCreateContainer'>
                        {optionsContainer.filter(filter => filter.IsHiddenList !== true).map((elem, keyForm) => {
                            const safeContainer = container || {}
                            const safeNewContainer = newContainer || {}
                            return (
                                elem.IsForeignKey ? (
                                    <M_DrawerTableTextField
                                        key={keyForm}
                                        tableLabel={elem.NormalizedName}
                                        label={elem.NormalizedName}
                                        required={elem.IsRequired}
                                        entity={elem.ForeignTableName}
                                        value={safeContainer[elem?.ForeignTableToPassId] ?
                                            {
                                                [elem.ForeignTableToPassId]: safeContainer[elem.ForeignTableToPassId],
                                                [elem.ForeignKeyName]: safeContainer[elem.Name]
                                            } : null}
                                        filterField={elem.ForeignKeyName}
                                        labelFields={[elem.ForeignKeyName]}
                                        onSubmitValue={obj => {
                                            setNewContainer(prevContainer => {
                                                const updatedContainer = { ...(prevContainer || {}) }

                                                if (obj) {
                                                    updatedContainer[elem.Name] = obj[elem.ForeignKeyName]
                                                    updatedContainer[elem.ForeignTableToPassId] = obj[elem.ForeignTableToPassId]
                                                } else {
                                                    updatedContainer[elem.Name] = null
                                                    updatedContainer[elem.ForeignTableToPassId] = null
                                                }
                                                return updatedContainer
                                            })

                                            let updatedContainer = { ...safeContainer }
                                            if (obj) {
                                                updatedContainer[elem.Name] = obj[elem.ForeignKeyName]
                                                updatedContainer[elem.ForeignTableToPassId] = obj[elem.ForeignTableToPassId]
                                            } else {
                                                updatedContainer[elem.Name] = null
                                                updatedContainer[elem.ForeignTableToPassId] = null
                                            }
                                            setContainer(updatedContainer)
                                        }}
                                        disabled={elem.Name === 'Type' ? (safeContainer?.Capacity) ? false : true : false}
                                        valueField={elem.ForeignTableToPassId}
                                        FILTER={elem.Name === 'Type' ? `containerCapacityId eq ${safeNewContainer.CapacityId || ''}` : null}
                                    />
                                ) : elem.Type === 'string' ? (
                                    < M_InputTextField
                                        key={keyForm}
                                        label={elem.NormalizedName}
                                        type={'text'}
                                        required={elem.IsRequired}
                                        disabled={elem.disable}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            if (elem.Name === 'ContainerNumber') {
                                                if (value.length === 6 && !value.includes('/')) {
                                                    value = value.slice(0, 6) + '/' + value.slice(6)
                                                }
                                            }
                                            createStructureNewContainer(value, elem.Name)
                                            createStructure(value, elem.Name, "Container")
                                        }}
                                        value={safeContainer[elem.Name] || ""}
                                        placeholder={elem.Name === 'ContainerNumber' ? 'xxxxxx/x' : null}
                                        maxNumbers={elem.Name === 'Acronym' ? 4 : elem.Name === 'ContainerNumber' ? 8 : null}

                                    />
                                ) : elem.Type === 'int32' ? (
                                    < M_InputTextField
                                        key={keyForm}
                                        label={elem.NormalizedName}
                                        type={'number'}
                                        required={elem.IsRequired}
                                        disabled={elem.disable}
                                        onChange={(e) => {
                                            createStructureNewContainer(e.target.value, elem.Name)
                                            createStructure(e.target.value, elem.Name, "Container")

                                        }}
                                        value={safeContainer[elem.Name] || ""}
                                    />
                                ) : null
                            )
                        })}
                    </div >
                }
                footer={
                    < div className='divFooterAlertsOrderService' >
                        <M_Button
                            backgroundColor={'var(--color-red)'}
                            label={t("Back")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                createStructure("", "ContainerNumber", "Container")
                                createStructureNewContainer("", "ContainerNumber")
                                setModalAddContainer(false)
                            }}
                        />
                        <M_Button
                            backgroundColor={'var(--color-green)'}
                            label={t("CreateNewContainer")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                createNewContainer()
                            }}
                        />
                    </div >
                }
            />

            {/* modal visualização da morada no mapa */}
            <M_MessageBoard
                title={t("Address")}
                open={modalViewAddress}
                onClose={() => setModalViewAddress(false)}
                body={
                    <div>
                        {selectedAddress !== null ? (
                            <>
                                {(() => {
                                    const tempAddress = address.find(a => a.Id === selectedAddress)
                                    if (!tempAddress || !tempAddress.Latitude || !tempAddress.Longitude) {
                                        return <p>{t("AddressNotFound")}</p>
                                    }

                                    const tempArray = [{
                                        latitude: tempAddress.Latitude,
                                        longitude: tempAddress.Longitude
                                    }]

                                    const tempInitialState = {
                                        latitude: tempAddress.Latitude,
                                        longitude: tempAddress.Longitude,
                                        zoom: 12
                                    }

                                    return (
                                        <div style={{ width: '100%', maxWidth: '100%', minWidth: ' 550px' }}>
                                            <MMap
                                                height={"450px"}
                                                className={"divMapOrderService"}
                                                navigationControl
                                                controlScale
                                                fullscreen
                                                findMyLoc
                                                satelliteView
                                                points={tempArray}
                                                initalMapState={tempInitialState}
                                            />
                                        </div>
                                    )
                                })()}
                            </>
                        ) : (
                            <p>{t("NoAddressSelected")}</p>
                        )}
                    </div>
                }
                footer={
                    <M_Button
                        backgroundColor={'var(--color-red)'}
                        label={t("Close")}
                        labelColor={'var(--color-white)'}
                        onClick={() => setModalViewAddress(false)}
                    />
                }
            />

            <M_MessageBoard
                title={<div className='divTitleMessageBoardInformation'>
                    <img src="/icons/svgsDaNet/alert-triangle.svg"
                        style={{ filter: 'invert(87%) sepia(14%) saturate(7477%) hue-rotate(7deg) brightness(98%) contrast(102%)', width: '35px', marginRight: '10px' }}
                        alt="container"
                    />
                    {t("ErrorInvalidContainer")}

                </div>
                }
                open={validateDistict}
                onClose={() => {
                    setValidateDistrict(false)
                    setInvalidContainerInfo({ acronym: '', containerNumber: '' })
                }}
                body={
                    <div>
                        <p>{t("ValidateDisticMessage")}</p>
                        <p><b>{t("Acronym")}:</b> {invalidContainerInfo.acronym || "-"}</p>
                        <p><b>{t("ContainerNumber")}:</b> {invalidContainerInfo.containerNumber || "-"}</p>
                    </div>
                }
                footer={
                    < div className='divFooterAlertsOrderService' >
                        <M_Button
                            backgroundColor={'var(--color-red)'}
                            label={t("No")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                createStructure("", "ContainerNumber", "Container")
                                createStructureNewContainer("", "ContainerNumber")
                                setValidateDistrict(false)
                                setInvalidContainerInfo({ acronym: '', containerNumber: '' })
                            }}
                        />
                        <M_Button
                            backgroundColor={'var(--color-green)'}
                            label={t("Yes")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setModalAddContainer(true)
                                setValidateDistrict(false)
                                setInvalidContainerInfo({ acronym: '', containerNumber: '' })
                            }}
                        />
                    </div >
                }
            />

        </div>
    )
}
